// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2ISk-","consentsList":"PatientConsents_consentsList__aFuGi","consentsListEmpty":"PatientConsents_consentsListEmpty__3Ugn0"};